import React from 'react'
import { Chip } from '../Goals/Goals.styled'

type UnassignedTasksChipProps = {
  numTasksComplete: number
  numTasksTotal: number
  taskStatusIndicator: JSX.Element
  taskStatusPercentage: number
}

export const TaskCompletionChip = ({
  numTasksComplete,
  numTasksTotal,
  taskStatusIndicator,
  taskStatusPercentage,
}: UnassignedTasksChipProps) => (
  <Chip variant={taskStatusPercentage === 100 ? 'completed' : undefined}>
    {taskStatusPercentage > 0 && taskStatusIndicator}
    {numTasksComplete} / {numTasksTotal} Tasks Completed
  </Chip>
)
